module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-woman-tee/2-28031077f4dd8363eb50024f90885656.jpg";